import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Score } from '../../models/score.model';
import { PoliticPartiesService } from '../../services/politic-parties.service';
import { QuestionsService } from '../../services/questions.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-questions',
	templateUrl: './questions.component.html',
	styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit, OnDestroy {
	public currentQuestionGroupIndex = 0;
	public currentQuestionIndex = 0;

	public currentQuestionGroup = {};
	public currentQuestions = [];
	public currentQuestion = {};

	public resultCode;
	public vclientCode;

	public finished = false;

	public politicParty: any = null;

	public score;
	public groupScore = '';

	public showButtons = true;
	public reaction = '';

	constructor(
		private renderer: Renderer2,
		private politicPartiesService: PoliticPartiesService,
		private questionsService: QuestionsService,
		private http: HttpClient,
		private route: ActivatedRoute
	) {
	}

	ngOnInit(): void {
		let clientCode = this.route.snapshot.paramMap.get('clientCode');
		this.setBGColor();

		this.setCurrentQuestionGroup();
		this.score = new Score();
		this.score.setClientCode(clientCode);
		this.score.setPoliticalParties(this.politicPartiesService.getPoliticalParties());

		this.vclientCode = clientCode;
		this.resultCode = sessionStorage.getItem('resultCode');

		if (!this.resultCode || this.resultCode == '' || this.resultCode == null) {
			sessionStorage.setItem('resultCode', this.generateId());
			this.resultCode = sessionStorage.getItem('resultCode');
		}

		console.log(this.questionsService.questionGroups);
	}

	ngOnDestroy() {
		this.setBGColor();
	}

	nextQuestion(key, questionType, answer, event) {

		(<HTMLInputElement>document.getElementById("disagree-button")).blur();
		(<HTMLInputElement>document.getElementById("agree-button")).blur();

		this.showButtons = false;

		if (questionType === 'party2') {
			questionType = 'party';
		} else if (questionType === 'party3') {
			questionType = 'party';
		}

		this.score.addAnswer(key, questionType, answer);

		this.currentQuestionIndex++;

		let element = this;
		setTimeout(function () {
			element.showButtons = true;
		}, 50);

		if (this.currentQuestionIndex == this.currentQuestions.length) {
			this.currentQuestionIndex = 0;
			this.currentQuestionGroupIndex++;
			element.groupScore = '';
		}

		console.dir(this.score.getParties());

		if (this.questionsService.getQuestionGroupCount() <= this.currentQuestionGroupIndex) {
			this.setFinished();
			return;
		}

		/*
		* Error: Better error catching? Specific error for no questions
		*/
		try {
			this.setCurrentQuestionGroup();
		} catch (e) {
			this.setFinished();
			return;
		}
	}

	setFinished() {
		this.setParty();
		this.finished = true;
		this.save();
	}

	save() {
		let postData = {};
		postData['token'] = this.resultCode;
		postData['code'] = this.score.getClientCode();
		postData['wing'] = this.score.getWing();
		postData['direction'] = this.score.getDirection();
		postData['party'] = this.score.getParty();

		this.http.post('https://jongerenstemtest.nl/api/save.php', postData)
			.subscribe(function (response) { });
	}

	setParty() {
		let politicalParties = this.politicPartiesService.getPoliticalParties();

		let currentParty = this.score.getParty();
		if (currentParty === null) {
			this.politicParty = null;
		} else {
			this.politicParty = politicalParties[currentParty];
		}
	}

	unsetFinished() {
		this.finished = false;
	}

	setCurrentQuestions() {
		try {
			console.dir(this.score.getParties());
		} catch (err) {

		}

		let questions = this.currentQuestionGroup['questions'];
		console.log(questions)

		if (this.currentQuestionGroup['questionType'] === 'party' || this.currentQuestionGroup['questionType'] === 'party2' || this.currentQuestionGroup['questionType'] === 'party3') {
			this.currentQuestions = [];
			for (let key in questions) {
				if (questions[key]['category'] === this.score.getPoliticalIdeoligy()) {
					this.currentQuestions.push(questions[key]);
				}
				if (typeof (this.score.getParties()) != 'undefined') {
					let questionKey = this.groupScore;
					if (questionKey == '') {
						questionKey = this.score.getWing() + '-' + this.score.getDirection() + '-' + this.score.getParties().sort().join('-');
					}
					if (questions[key]['category'] === questionKey) {
						this.currentQuestions.push(questions[key]);
					}
				}
			}
		} else {
			this.currentQuestions = questions;
		}
	}

	setCurrentQuestionGroup() {
		this.currentQuestionGroup = this.questionsService.getQuestionGroup(this.currentQuestionGroupIndex);
		this.setCurrentQuestions();

		if (typeof (this.currentQuestions[this.currentQuestionIndex]) == 'undefined') {
			throw 'No questions';
		} else {
			this.currentQuestion = this.currentQuestions[this.currentQuestionIndex];
			console.log(this.currentQuestion)
			try {
				let questionKey = this.score.getWing() + '-' + this.score.getDirection() + '-' + this.score.getParties().sort().join('-');
				this.groupScore = questionKey;
			} catch (e) {
			}
		}
	}

	resetQuestions() {
		this.currentQuestionIndex = 0;
		this.currentQuestionGroupIndex = 0;

		this.setCurrentQuestionGroup();
		this.score = new Score();

		this.unsetFinished();
	}

	getPercentage(groupindex, index, max) {
		let currentPercentage = (((index) / max) * 100);
		let newPercentage = ((groupindex * 33.33333) + (currentPercentage / 3)) + '%';

		console.log(newPercentage)

		if(((groupindex * 33.33333) + (currentPercentage / 3)) == 99.99999) {
			newPercentage = 90 + '%';
		}

		return newPercentage;
	}

	setBGColor() {
		let shuffleColors = ["#7E78B8", "#F06793", "#FCBA63", "#51BF9D", "#44C8F5"];
		let chooseRandomColor = Math.floor(Math.random() * shuffleColors.length);

		this.renderer.setStyle(document.body, 'background-color', shuffleColors[chooseRandomColor]);
	}

	generateId() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	saveReaction(reaction) {
		this.reaction = reaction;

		let postData = {};
		postData['reaction'] = this.reaction;
		postData['token'] = this.resultCode;

		this.http.post('https://jongerenstemtest.nl/api/saveReaction.php', postData)
			.subscribe(function (response) { });
	}
}
